import { render, staticRenderFns } from "./AmountGrantTable.vue?vue&type=template&id=57fa6afe&"
import script from "./AmountGrantTable.vue?vue&type=script&lang=js&"
export * from "./AmountGrantTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports